import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../core/defaultValues";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { resetALL } from "../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../core/logManager";

const INIT_STATE = {
    loading: false,
    customer: null
};

const route = "modules/workOrders/views/main/components/customerDetail/redux/slice.";

export const workOrdersCustemerDetailGetCustomers = createAsyncThunk("workOrders/customerDetail/getCustomers", async (payload, { rejectWithValue }) => {
    try {
        const response = await clientQuery(
            `
                query getCustomer ($id: Int!) {
                    data: getCustomer (id: $id) {
                        id
                        name
                        ein
                        customerContact {
                            id
                            name
                            email
                            phone
                        }
                        customerLocation {
                            id
                            name
                            address
                        }
                        tagIds
                        tags {
                            id
                            label
                            color
                        }
                    }
                }
            `,
            payload,
            endpoints.GRAPHQL_GENERAL_V2
        );
        return response?.data
    } catch (exc) {
        ExceptionManager(exc, route, "getCustomers");
        return rejectWithValue(exc);
    }
}
);

//Slice
const workOrdersCustomerDetailRedux = createSlice({
    name: "workOrders/customerTab",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //workOrdersCustemerDetailGetCustomers
        builder.addCase(workOrdersCustemerDetailGetCustomers.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrdersCustemerDetailGetCustomers.fulfilled, (state, action) => {
            state.loading = false;
            state.customer = action.payload
        });
        builder.addCase(workOrdersCustemerDetailGetCustomers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersCustomerDetailRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
